import React from 'react';

function InviteSending() {
  return <>Your invitations have been sent and Profyle will alert you each time someone responds.</>;
}

export { InviteSending };
